import styles from './loader.module.scss';

export const Loader = () => {
	return (
		<div className={styles.loaderBox}>
			<div className={styles.loader}></div>
		</div>
	);
};
